import React, { useContext } from 'react';
import { Box, List, ListItem, Text } from '@chakra-ui/react';
import { FaBell } from 'react-icons/fa';
import DepositContext from './DepositContext';

const DepositNotifications = () => {
  const { notifications } = useContext(DepositContext);
console.log(notifications)
  return (<>
     {notifications&&notifications?.length!=0&&<Box>  <Text fontSize="2xl" mb={4}><FaBell /> Notifications</Text>
      <List spacing={3}>
        {notifications&&notifications?.map(notification => (
          <ListItem key={notification._id}>
            {notification.item.name} - {notification.amount} - {notification.status}
          </ListItem>
        ))}
      </List>
    </Box>}
    </>
  );
};

export default DepositNotifications;
